<template>
  <path d="M24 6h-24v-4h24v4zm0 4h-24v4h24v-4zm0 8h-24v4h24v-4z"/>
</template>

<script>
export default {
  name: 'IconMenu'
}
</script>



// WEBPACK FOOTER //
// src/components/icons/IconMenu.vue